import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import AIcon from '@/components/A/AIcon/AIcon'
import SwitchCorpOption from '../SwitchCorpOption/SwitchCorpOption'
import SwitchLanguageOption from '../SwitchLanguageOption/SwitchLanguageOption'
import styles from './UserActionPanel.module.less'

type CorpMenuItem = {
  key: string
  name: string
}

type Props = {
  className?: string
  corpList: CorpMenuItem[]
  currentCorpKey?: string
  currentCorpName: string
  onChangeCorp: (corpId: string) => void
  onLogout: () => void
}

function UserActionPanel(props: Props) {
  const { t } = useTranslation()

  return (
    <div className={classNames(styles.userActionPanel, props.className)} data-testid='nav-user-action-panel'>
      <SwitchCorpOption
        corpList={props.corpList}
        currentCorpKey={props.currentCorpKey}
        currentCorpName={props.currentCorpName}
        onChangeCorp={props.onChangeCorp}
      />
      <SwitchLanguageOption />
      <button
        type='button'
        data-testid='nav-logout-btn'
        className={classNames(styles.logoutRow, styles.logoutRowButton)}
        onClick={props.onLogout}
      >
        <span className={styles.logoutRowLeft}>
          <AIcon type='icon-tuichudenglu' width={17} height={17} />
          {t('dashboard.layout.logout')}
        </span>
      </button>
    </div>
  )
}

export default UserActionPanel
